function hasApiNumber(value) {
  return value !== undefined && value !== null && value !== "";
}

export function toBillingNumber(value) {
  const n = Number.parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

export function resolveValorModulosTotal(data) {
  if (!data) {
    return 0;
  }
  if (hasApiNumber(data.valor_modulos_total)) {
    return toBillingNumber(data.valor_modulos_total);
  }
  return toBillingNumber(data.valor_modulos);
}

export function resolveValorModulosFixos(data) {
  if (!data) {
    return 0;
  }
  if (hasApiNumber(data.valor_modulos_fixos)) {
    return toBillingNumber(data.valor_modulos_fixos);
  }
  return toBillingNumber(data.valor_modulos);
}

export function resolveValorModulosLicencas(data) {
  return toBillingNumber(data && data.valor_modulos_licencas_contratadas);
}

export function deveExibirDecomposicaoModulos(valorLicencas) {
  return toBillingNumber(valorLicencas) > 0;
}
